import { Component, forwardRef, ContentChildren, QueryList, AfterContentInit, Input, OnDestroy } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { Subscription } from "rxjs";

import { createCustomInputControlValueAccessor } from "@shared/FormShared/Helpers/form.helper";

import { RadioButtonComponent } from "../radio-button/radio-button.component";

let nextUniqueId = 0;

@Component({
  selector: "uni-radio-group",
  template: ` <ng-content></ng-content> `,
  providers: [createCustomInputControlValueAccessor(RadioGroupComponent)],
})
export class RadioGroupComponent implements ControlValueAccessor, AfterContentInit, OnDestroy {
  @ContentChildren(forwardRef(() => RadioButtonComponent)) public radioButtons?: QueryList<RadioButtonComponent>;

  public onChange: (value: string) => void;
  private onTouched: () => void;
  private subscriptions: Subscription[] = [];

  @Input()
  public get name(): string {
    return this._name || this.id;
  }
  public set name(value: string) {
    this._name = value;
  }
  private _name: string;
  protected id = `uni-radio-${nextUniqueId++}`;

  public ngAfterContentInit(): void {
    this.handleRadioButtonsChange(this.radioButtons);

    this.subscriptions.push(
      this.radioButtons.changes.subscribe((radioButtons: QueryList<RadioButtonComponent>) => {
        this.handleRadioButtonsChange(radioButtons);
      })
    );
  }

  private handleRadioButtonsChange(radioButtons: QueryList<RadioButtonComponent>): void {
    if (!radioButtons || radioButtons.length === 0) {
      return;
    }

    radioButtons.forEach((radioButton) => {
      this.subscriptions.push(
        radioButton.checked.subscribe((value) => {
          this.onChange(value);
          this.onTouched();
        })
      );
    });
  }

  public writeValue(value: string): void {
    if (!this.radioButtons) return;

    this.radioButtons?.forEach((radioButton) => {
      radioButton.checkedValue = value;
    });
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.radioButtons?.forEach((radioButton) => {
      radioButton.disabled = isDisabled;
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
